const addAttributeToEachObjectInArray = (array, attrName, defaultValue) => {
  return array.map(obj => {
    if (typeof(obj) === 'object')
      obj[attrName] = defaultValue;
    return obj;
  });
};

export default addAttributeToEachObjectInArray;
